/** Общие утилиты localStorage для мок-мутаций (до появления бэкенда). */
export function readJsonArray<T>(key: string): T[] {
  try {
    const r = localStorage.getItem(key);
    return r ? JSON.parse(r) : [];
  } catch {
    return [];
  }
}

export function appendJsonArray<T>(key: string, item: T): void {
  const arr = readJsonArray<T>(key);
  arr.push(item);
  localStorage.setItem(key, JSON.stringify(arr));
}
